import React, { useState } from 'react';
import { Label } from './ui/label';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { toast } from 'sonner';
import { appointmentsAPI } from '../services/api';
import { CalendarDays, Clock, Video } from 'lucide-react';

const ConsultationSection = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    dateTime: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    try {
      // Send to Formspree
      const formspreeResponse = await fetch('https://formspree.io/f/meegyjlr', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          dateTime: formData.dateTime,
          type: 'Консультация',
          _subject: `Новая запись на консультацию - ${formData.name}`
        })
      });

      // Also save to database
      const appointmentData = {
        ...formData,
        date: new Date().toISOString(),
        message: formData.dateTime,
        type: 'consultation'
      };

      await appointmentsAPI.create(appointmentData);

      setIsSubmitting(false);

      if (formspreeResponse.ok) {
        toast.success('Заявка отправлена!', {
          description: `Подтверждение отправлено на ${formData.email}`
        });

        setFormData({ name: '', email: '', phone: '', dateTime: '' });
      } else {
        toast.error('Ошибка отправки', {
          description: 'Попробуйте позже'
        });
      }
    } catch (error) {
      setIsSubmitting(false);
      toast.error('Ошибка отправки', {
        description: 'Попробуйте позже'
      });
    }
  };

  return (
    <section id="consultation" className="py-24 bg-cream-white">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="font-serif text-4xl md:text-5xl text-charcoal mb-6">
              Консультации
            </h2>
            <p className="text-lg text-warm-gray max-w-2xl mx-auto leading-relaxed">
              Запишитесь на пробную консультацию и начните свой путь к изменениям
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="bg-soft-gray p-6 rounded-2xl text-center">
              <div className="w-16 h-16 rounded-full bg-warm-sage/20 flex items-center justify-center mx-auto mb-4">
                <Clock className="text-warm-sage" size={28} />
              </div>
              <h3 className="font-semibold text-charcoal mb-2">Длительность</h3>
              <p className="text-warm-gray text-sm">60 минут</p>
            </div>

            <div className="bg-soft-gray p-6 rounded-2xl text-center">
              <div className="w-16 h-16 rounded-full bg-warm-sage/20 flex items-center justify-center mx-auto mb-4">
                <Video className="text-warm-sage" size={28} />
              </div>
              <h3 className="font-semibold text-charcoal mb-2">Формат</h3>
              <p className="text-warm-gray text-sm">Онлайн / Оффлайн</p>
            </div>

            <div className="bg-soft-gray p-6 rounded-2xl text-center">
              <div className="w-16 h-16 rounded-full bg-warm-sage/20 flex items-center justify-center mx-auto mb-4">
                <CalendarDays className="text-warm-sage" size={28} />
              </div>
              <h3 className="font-semibold text-charcoal mb-2">Гибкое расписание</h3>
              <p className="text-warm-gray text-sm">Выберите удобное время</p>
            </div>
          </div>

          <div className="bg-soft-gray p-8 md:p-12 rounded-3xl">
            <div className="max-w-xl mx-auto">
              {/* Form */}
              <div>
                <h3 className="font-serif text-2xl text-charcoal mb-6 text-center">Ваши данные</h3>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <Label htmlFor="name">Имя *</Label>
                    <Input
                      id="name"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      required
                      placeholder="Ваше имя"
                    />
                  </div>
                  
                  <div>
                    <Label htmlFor="email">Email *</Label>
                    <Input
                      id="email"
                      type="email"
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      required
                      placeholder="your@email.com"
                    />
                  </div>

                  <div>
                    <Label htmlFor="phone">Телефон *</Label>
                    <Input
                      id="phone"
                      type="tel"
                      value={formData.phone}
                      onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                      required
                      placeholder="+31 6 12345678"
                    />
                  </div>

                  <div>
                    <Label htmlFor="dateTime">Желаемая дата и время для записи *</Label>
                    <Textarea
                      id="dateTime"
                      value={formData.dateTime}
                      onChange={(e) => setFormData({ ...formData, dateTime: e.target.value })}
                      placeholder="Например: 15 февраля в 15:00 или в любой день следующей недели после 16:00"
                      rows={3}
                      required
                    />
                  </div>

                  <button type="submit" className="btn-primary w-full" disabled={isSubmitting}>
                    {isSubmitting ? 'Отправка...' : 'Отправить заявку'}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConsultationSection;
